import script from "./PubFollowInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PubFollowInfo.vue?vue&type=script&setup=true&lang=js"

import "./PubFollowInfo.vue?vue&type=style&index=0&id=1395e1f5&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1395e1f5"]])

export default __exports__